import { STATIC_ACTIONS } from '~/Constants/Actions.constants';
import { ThunkAction } from 'redux-thunk';
import { dispatchSuccess } from '~/Helpers/Request.helper';
import { NeoState } from '~/store';
import { INeoAction } from '~/store/Actions.interface';
import { AccessRoles, FitogramVersion } from '~/Hooks/useHasAccess/accessList.types';

export const requestUpdateMockAccessUserView = (
  payload: AccessRoles,
): ThunkAction<any, NeoState, unknown, INeoAction> => async (dispatch) =>
  dispatchSuccess(dispatch, STATIC_ACTIONS.UPDATE_MOCK_ACCESS_USER_VIEW, payload, {});

export const requestUpdateMockAccessAppView = (
  payload: FitogramVersion,
): ThunkAction<any, NeoState, unknown, INeoAction> => async (dispatch) =>
  dispatchSuccess(dispatch, STATIC_ACTIONS.UPDATE_MOCK_ACCESS_APP_VIEW, payload, {});

export const requestUpdateMockAccessIsInMockMode = (
  payload?: boolean,
): ThunkAction<any, NeoState, unknown, INeoAction> => async (dispatch) =>
  dispatchSuccess(dispatch, STATIC_ACTIONS.UPDATE_MOCK_ACCESS_IS_IN_MOCK_MODE, payload, {});
